document.addEventListener("DOMContentLoaded", () => {
  const bar = document.querySelector("#limited-offer-bar");
  if (!bar) return;

  const endDate = bar.dataset.timer;   // e.g. "Dec 05, 2025 23:59"
  if (!endDate) return;

  const end = new Date(endDate).getTime();

  const hoursEl = bar.querySelector("[data-hours]");
  const minEl   = bar.querySelector("[data-minutes]");
  const secEl   = bar.querySelector("[data-seconds]");

  const tick = setInterval(() => {
    const now = Date.now();
    const diff = end - now;

    if (diff <= 0) {
      bar.style.display = "none";
      clearInterval(tick);
      return;
    }

    const hours = Math.floor(diff / (1000 * 60 * 60));
    const mins  = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
    const secs  = Math.floor((diff % (1000 * 60)) / 1000);

    hoursEl.textContent = String(hours).padStart(2, "0");
    minEl.textContent   = String(mins).padStart(2, "0");
    secEl.textContent   = String(secs).padStart(2, "0");

  }, 1000);
});

// document.addEventListener("DOMContentLoaded", function() {

//   const compAddButtons = document.querySelectorAll("[data-comp-add-btn]");

//   compAddButtons.forEach(button => {
//     const originalText = button.textContent.trim(); // store original text

//     button.addEventListener("click", function(event) {
//       event.preventDefault();
//       event.stopImmediatePropagation();
//       event.stopPropagation();

//       // Show "Adding..."
//       this.textContent = "Adding...";
//       this.classList.add("comp-adding");

//       const id = this.getAttribute("data-product-id");

//       fetch("/cart/add.js", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({ id: id, quantity: 1 })
//       })
//       .then(res => res.json())
//       .then(() => {

//         // Reload cart drawer
//         if (typeof reloadCart === "function") {
//           reloadCart(() => {
//             if (typeof openCartDrawer === "function") {
//               openCartDrawer();
//             }
//           });
//         } else if (typeof openCartDrawer === "function") {
//           openCartDrawer();
//         }

//         // Show "Added"
//         this.textContent = "✓ Added";
//         this.classList.remove("comp-adding");
//         this.classList.add("comp-added");

//         // Reset back after 2 seconds
//         setTimeout(() => {
//           this.textContent = originalText;
//           this.classList.remove("comp-added");
//         }, 2000);

//       })
//       .catch(err => {
//         console.error("Error:", err);
//         this.textContent = originalText; // fallback on error
//       });
//     });
//   });

// });

document.addEventListener("DOMContentLoaded", () => {
  // Select all temp add-to-cart buttons
  const tempButtons = document.querySelectorAll(".template-product [data-add-btn]");

  // Main CTA button
  const mainCTA = document.querySelector(".product-information-buy-buttons-row #product-information-cart-button");

  if (tempButtons.length && mainCTA) {
    tempButtons.forEach(btn => {
      btn.addEventListener("click", (e) => {
        e.preventDefault(); // stop default action

        // Scroll to main CTA
        mainCTA.scrollIntoView({
          behavior: "smooth",
          block: "center"
        });

  
      });
    });
  }
});



document.addEventListener("DOMContentLoaded", function () {

  function getProductJson(productId) {
    return window["cr_new_product_" + productId] || null;
  }

  // Function to create a resized image URL
  function getResizedImage(url, size) {
    if (!url) return url;

    // Example: image.jpg → image_600x.jpg
    return url.replace(/(\.[a-zA-Z]{3,4})(\?.*)?$/, `_${size}$1`);
  }

  const productCards = document.querySelectorAll(".card-product");

  productCards.forEach(card => {
    const swatches = card.querySelectorAll(".swatch-item");
    if (!swatches.length) return;

    swatches.forEach(swatch => {
      swatch.addEventListener("click", function () {

        const variantId = this.dataset.variantId;
        const productId = this.dataset.productId;

        const productJson = getProductJson(productId);

        if (!productJson || !productJson.variants) {
          console.warn("Product JSON not found for product:", productId);
          return;
        }

        const variant = productJson.variants.find(v => v.id == variantId);
        if (!variant || !variant.featured_image) return;

        const mainImg = card.querySelector(".card-product-image img");
        if (!mainImg) return;

        // Build optimized URL
        const newImgUrl = getResizedImage(variant.featured_image.src, "600x");

        // Update main image
        mainImg.src = newImgUrl;
        mainImg.srcset = newImgUrl;

        // Active class
        swatches.forEach(s => s.classList.remove("active"));
        this.classList.add("active");
      });
    });
  });

});




(function () {
  function updateUpsellVariantId(formEl) {
    const jsonEl = formEl.querySelector('[data-upsell-variants]');
    if (!jsonEl) return;

    let variants;
    try {
      variants = JSON.parse(jsonEl.textContent);
    } catch (e) {
      console.error('Upsell variants JSON parse failed', e);
      return;
    }

    const selectedOptions = Array.from(formEl.querySelectorAll('.upsell-variant-select'))
      .map(s => s.value);

    const matched = variants.find(v =>
      Array.isArray(v.options) &&
      v.options.length === selectedOptions.length &&
      v.options.every((opt, i) => opt === selectedOptions[i])
    );

    if (matched) {
      const idInput = formEl.querySelector('.upsell-variant-id');
      if (idInput) idInput.value = matched.id;
    }
  }

  // change handler (works even after drawer reload)
  document.addEventListener('change', function (e) {
    if (!e.target.classList.contains('upsell-variant-select')) return;
    const form = e.target.closest('.upsell-form');
    if (form) updateUpsellVariantId(form);
  });

  // initialize on load + after cart drawer HTML re-renders
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.upsell-form').forEach(updateUpsellVariantId);
  });

  // If your theme redraws the drawer via AJAX, this helps re-init after reloadCart()
  document.addEventListener('cart:refresh', function () {
    document.querySelectorAll('.upsell-form').forEach(updateUpsellVariantId);
  });
})();



$(document).on('submit', '[data-upsell-form]', function (event) {
  event.preventDefault();

  const $form = $(this);
  const $button = $form.find('.upsell-add-btn');

  if ($button.prop('disabled')) return;

  $button.prop('disabled', true).text('Adding…');

  $.ajax({
    type: 'POST',
    url: getShopifyApiRoot() + 'cart/add.js',
    dataType: 'json',
    data: $form.serialize(),

    success: function () {

      /* ✅ DO EXACTLY WHAT THE THEME DOES */
      reloadCart(function () {

        openCartDrawer(); // REQUIRED in this theme

        $button.text('Added ✓');
        setTimeout(function () {
          $button.text('+ ADD').prop('disabled', false);
        }, 1200);
      });
    },

    error: function () {
      alert('Error adding product');
      $button.prop('disabled', false).text('+ ADD');
    }
  });
});



